import { useApiFetcherSWR } from "hooks/SwrCustom";


export const API_ENDPOINT = {

  GET_ABSENT_DASHBOARD: {
    url: "requests",
    method: "get",
  }
};

export const useAbsentDashboard = (params = {}) =>
  useApiFetcherSWR(
    {
      ...API_ENDPOINT.GET_ABSENT_DASHBOARD,
      params,
    },
  );